var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _rect, _path7, _rect2, _polygon2, _path8, _path9, _path0, _path1, _path10, _path11, _rect3, _rect4, _rect5, _rect6, _rect7, _path12, _path13, _rect8, _rect9, _rect0, _path14, _path15, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _polygon3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse, _polygon4, _polygon5, _path24, _path25, _path26, _g, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _polygon6, _path34, _path35, _path36, _path37, _path38, _path39, _polygon7, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _circle, _path63, _circle2, _circle3, _path64, _rect25, _rect26, _circle4, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path81, _path82, _path83, _g2, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _ellipse2, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _rect27, _rect28, _rect29, _rect30, _rect31, _path110, _path111, _path112, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _rect32, _rect33, _circle21, _circle22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManOnTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bfc59778-adb9-4ded-81d5-12977ec092f3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 996.46,
    height: 828.18,
    viewBox: "0 0 996.46 828.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e507827f-2863-48fa-82fe-b741cb149057",
    x1: -925.56,
    y1: 683.71,
    x2: -925.56,
    y2: 144.42,
    gradientTransform: "matrix(-1, 0, 0, 1, -573.82, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "on the office") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1096.36,308.36h-91.94V419.81h85.22c.22,1.15.43,2.3.68,3.44h-85.9v89.86l.43-.14q3.64-1.28,7.23-2.72l1.54-.63q3.68-1.51,7.23-3.23c.85-.39,1.69-.8,2.52-1.22a149.83,149.83,0,0,0,36.17-25c.31-.27.6-.55.88-.82,1.47-1.42,2.91-2.85,4.31-4.32l1.54-1.64c1.65-1.79,3.24-3.64,4.79-5.51l.68-.82a116.4,116.4,0,0,0,15.58-25c.13-.27.24-.55.36-.82,1.25-2.82,2.38-5.68,3.36-8.59.42-1.23.82-2.46,1.17-3.69.12-.37.23-.73.33-1.09,5.1-17.85,5.69-36.4,5.69-54.85,0-2.15,0-4.31,0-6.45,0-7.45-.11-15-.25-22.45,0-1.94-.09-3.87-.14-5.82q-.18-7.43-.54-14.84c-.06-1.38-.12-2.75-.21-4.11,0-.79-.08-1.58-.13-2.37C1096.76,314.05,1096.58,311.21,1096.36,308.36Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,184.29h50.43A344.83,344.83,0,0,0,1028,151.45c-7.5-8.18-15.37-16.16-23.61-23.84Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,187.73V304.92h91.65c0-.34-.06-.69-.09-1-.08-.92-.16-1.84-.25-2.77s-.21-2.16-.33-3.25-.24-2.35-.38-3.51-.26-2.35-.41-3.52-.29-2.34-.45-3.5-.31-2.34-.49-3.5c-.14-1-.27-1.92-.42-2.89-.21-1.36-.43-2.73-.66-4.08a5.78,5.78,0,0,0-.11-.6,251.24,251.24,0,0,0-6.74-29.43A202.47,202.47,0,0,0,1074.37,217a216.88,216.88,0,0,0-17.11-29.3Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M786.08,308.36V419.81H982.46V308.36Zm0,114.89v75.47c22.86-7.31,49-4.36,72.7,1.64,18.35,4.66,36.23,11,54.55,15.56a200.08,200.08,0,0,0,24.87,4.7l2.06.22c1,.1,2,.2,3,.28l3,.21.31,0,1.34,0a3.55,3.55,0,0,0,.46,0l1.62.06h.05c.77,0,1.55,0,2.33.06h1c.77,0,1.55,0,2.33,0l1.71,0,1.38,0c.59,0,1.17,0,1.75-.06.94,0,1.88-.08,2.83-.15a0,0,0,0,0,0,0l1.75-.11,2.16-.17c1.53-.12,3-.28,4.55-.46.6-.07,1.21-.14,1.81-.23l.89-.11c1.51-.2,3-.44,4.51-.69,1.11-.17,2.22-.38,3.34-.58V423.25Zm146.06-239v3.44H786.08V304.92H982.46V187.73h-9.85v-3.44h9.85V108.55c-38.2-30.77-82.85-54.87-132.58-66a282,282,0,0,0-63.8-6.65V184.29Zm-449-.66.69.66H764.11V36.93c-49.9,4.15-98.56,20.91-137.79,48.68-18.85,13.33-35.78,29.13-56.93,39.36a89.15,89.15,0,0,1-35.6,9.2Zm-1.93-60.44v33.35l27.08-26.43C498.22,126.59,490.28,124.21,481.17,123.19Zm-.9,419.56.9,0v73.1q15.33-1.14,30.54-3.14A546.44,546.44,0,0,0,644,578.41h0q6.84-2.74,13.58-5.66,4.49-1.95,8.93-4,6.66-3.06,13.22-6.29A465.15,465.15,0,0,0,735.6,530c1.11-.75,2.23-1.51,3.33-2.28q3.32-2.3,6.59-4.64c1.09-.79,2.18-1.58,3.26-2.38L751,519c2.24-1.67,4.47-3.35,6.73-5h0c2.09-1.5,4.2-3,6.34-4.4v-86.4H538.92c.16-.51.31-1,.48-1.54-.18.52-.34,1-.49,1.54H481.17V542.69Zm.9-355V304.92H764.11V187.73Zm0,120.63V419.81H764.11V308.36ZM424.65,126.58l34.56,33.73V123Q441.84,124.08,424.65,126.58ZM184,308.36V419.81H459.21V308.36Zm66.52,275.25a511.15,511.15,0,0,0,129.73,30.78l.19,0q12.59,1.33,25.25,2.06l.31,0h0c17.69,1,35.45,1.23,53.18.57V423.25H184l1,128.32M107.77,419.81h54.28V308.36H140.58c-2.23,3.92-4.39,7.86-6.44,11.86q-1.65,3.19-3.21,6.45C116.8,356,107.82,388.24,107.77,419.81Zm0,3.44c.44,22.64,5.54,44.86,16.73,65.39,9.3,17.05,22.22,32,37.51,45V423.25Zm34.78-118.33h19.46v-29A309.35,309.35,0,0,0,142.59,304.92ZM264.48,184.29H452.72l.68-.66-1-1h0L399.47,131A429.83,429.83,0,0,0,353,143.45c-1.44.47-2.88,1-4.31,1.45A421.47,421.47,0,0,0,264.48,184.29ZM184,249.66v55.26H425.36l0,0,.05,0h33.83v-114l-3.86-3.14H258.94A377.73,377.73,0,0,0,184,249.66Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,246.84v58.08h91.65c0-.34-.06-.69-.09-1-.08-.92-.16-1.84-.25-2.77s-.21-2.16-.33-3.25-.24-2.35-.38-3.51-.26-2.35-.41-3.52-.29-2.34-.45-3.5-.31-2.34-.49-3.5c-.14-1-.27-1.92-.42-2.89-.21-1.36-.43-2.73-.66-4.08a5.78,5.78,0,0,0-.11-.6,251.24,251.24,0,0,0-6.74-29.43Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.36,308.36h-91.94V419.81h85.22c.22,1.15.43,2.3.68,3.44h-85.9v89.86l.43-.14q3.64-1.28,7.23-2.72l1.54-.63q3.68-1.51,7.23-3.23c.85-.39,1.69-.8,2.52-1.22a149.83,149.83,0,0,0,36.17-25c.31-.27.6-.55.88-.82,1.47-1.42,2.91-2.85,4.31-4.32l1.54-1.64c1.65-1.79,3.24-3.64,4.79-5.51l.68-.82a116.4,116.4,0,0,0,15.58-25c.13-.27.24-.55.36-.82,1.25-2.82,2.38-5.68,3.36-8.59.42-1.23.82-2.46,1.17-3.69.12-.37.23-.73.33-1.09,5.1-17.85,5.69-36.4,5.69-54.85,0-2.15,0-4.31,0-6.45,0-7.45-.11-15-.25-22.45,0-1.94-.09-3.87-.14-5.82q-.18-7.43-.54-14.84c-.06-1.38-.12-2.75-.21-4.11,0-.79-.08-1.58-.13-2.37C1096.76,314.05,1096.58,311.21,1096.36,308.36Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "811.56 168.6 811.56 269.01 880.69 269.01 880.69 168.6 870.84 168.6 870.84 134.6 830.37 134.6 830.37 168.6 811.56 168.6",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 811.56,
    y: 272.45,
    width: 69.13,
    height: 111.44,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M982.46,423.25H913.34v92.67a201.42,201.42,0,0,0,24.86,4.7l2.06.22c1,.11,2,.2,3,.28l3,.21c.1,0,.21,0,.31,0,.44,0,.89,0,1.34.06l.46,0c.54,0,1.08,0,1.63.06h0c.77,0,1.55,0,2.33.06h1c.78,0,1.55,0,2.33,0l1.71,0,1.38,0,1.76-.06c.93,0,1.88-.08,2.82-.15a0,0,0,0,0,0,0l1.74-.11,2.17-.17c1.52-.13,3-.28,4.54-.46l1.81-.23.89-.11c1.51-.21,3-.43,4.51-.69,1.12-.17,2.22-.38,3.34-.58Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 156.74,
    width: 57.01,
    height: 112.26,
    fill: "#6c63ff",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "379.4 272.45 379.4 383.9 662.34 383.9 662.34 335.83 511.63 335.83 511.63 364.19 436.4 364.19 436.4 272.45 379.4 272.45",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M480.27,542.75l.9,0v73.11q15.33-1.16,30.54-3.14A547.41,547.41,0,0,0,644,578.41q18.24-7.32,35.73-15.94A465.15,465.15,0,0,0,735.6,530q6.69-4.54,13.17-9.29c3-2.21,6-4.46,9-6.65,2.09-1.5,4.2-3,6.34-4.41V423.25H538.93c.16-.51.31-1,.47-1.53-.17.51-.34,1-.49,1.53H481.17V542.7Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5,184.29h37.14V174H353V143.45c-1.44.47-2.88,1-4.31,1.45V174H332.5Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M243,304.92H425.36l-.06,0,.09,0h33.82V192.65h-9.58v83h-43.8V226.53H369.64v-38.8H332.5v38.8H296.32v49.11H243Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M243,308.36V419.81H459.21V308.36Zm7.55,275.25a511.15,511.15,0,0,0,129.73,30.78l.19,0q12.59,1.33,25.25,2.06l.31,0h0c17.69,1,35.45,1.23,53.18.57V423.25H243v39.51H184l.31,88.21",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.24,423.25H107.81c.44,22.64,5.55,44.86,16.73,65.39,9.3,17.06,22.23,32,37.51,45V462.76h-3.81Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.77,419.81h50.47V326.67H130.93C116.8,356,107.82,388.24,107.77,419.81Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 187.95,
    width: 30.54,
    height: 35.2,
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 260.91,
    width: 30.54,
    height: 8.1,
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 272.45,
    width: 30.54,
    height: 23.65,
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 333.86,
    width: 30.54,
    height: 35.2,
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 379.4,
    y: 406.82,
    width: 30.54,
    height: 35.2,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M481.17,542.7l-.9,0,.9,0v8.17h30.54v-35.2H481.17Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M481.17,588.63v27.19q15.33-1.16,30.54-3.14v-24Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 531.46,
    y: 381.31,
    width: 130.88,
    height: 2.58,
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 531.46,
    y: 387.34,
    width: 130.88,
    height: 9.91,
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 531.46,
    y: 429.73,
    width: 130.88,
    height: 15.94,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M633.23,514.06V530H735.61q6.67-4.53,13.17-9.3c3-2.2,6-4.45,9-6.63Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M633.23,562.47v15.94H644q18.23-7.3,35.72-15.94Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 380.26,
    y: 319.16,
    width: 25.76,
    height: 22.91,
    transform: "translate(684.52 625.33) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 938.14,
    y: 212.41,
    width: 25.76,
    height: 22.91,
    transform: "translate(1800.26 411.82) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 938.14,
    y: 265.63,
    width: 25.76,
    height: 22.91,
    transform: "translate(1800.26 518.26) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 938.14,
    y: 318.85,
    width: 25.76,
    height: 22.91,
    transform: "translate(1800.26 624.69) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 938.14,
    y: 372.07,
    width: 25.76,
    height: 22.91,
    transform: "translate(1800.26 731.13) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 938.14,
    y: 425.28,
    width: 25.76,
    height: 22.91,
    transform: "translate(1800.26 837.57) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 938.14,
    y: 478.5,
    width: 25.76,
    height: 22.91,
    transform: "translate(1800.26 944) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 281.9,
    y: 319.16,
    width: 25.76,
    height: 22.91,
    transform: "translate(487.8 625.33) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 380.26,
    y: 375.68,
    width: 25.76,
    height: 22.91,
    transform: "translate(684.52 738.35) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 281.9,
    y: 375.68,
    width: 25.76,
    height: 22.91,
    transform: "translate(487.8 738.35) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 380.26,
    y: 432.19,
    width: 25.76,
    height: 22.91,
    transform: "translate(684.52 851.37) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 281.9,
    y: 432.19,
    width: 25.76,
    height: 22.91,
    transform: "translate(487.8 851.37) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 380.26,
    y: 488.7,
    width: 25.76,
    height: 22.91,
    transform: "translate(684.52 964.39) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 281.9,
    y: 488.7,
    width: 25.76,
    height: 22.91,
    transform: "translate(487.8 964.39) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 380.26,
    y: 545.21,
    width: 25.76,
    height: 22.91,
    transform: "translate(684.52 1077.42) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 281.9,
    y: 545.21,
    width: 25.76,
    height: 22.91,
    transform: "translate(487.8 1077.42) rotate(-180)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "304.25 580.58 304.25 565.81 278.5 565.81 278.5 578.48 304.25 580.58",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,276.26v13.11h88.17V276.26Zm79.39.83H1091v11.46h-7.23Zm-8.78,0h7.23v11.46H1075Zm-8.76,0h7.23v11.46h-7.23Zm-8.78,0h7.23v11.46h-7.23Zm-8.77,0H1056v11.46h-7.23Zm-8.78,0h7.23v11.46h-7.23Zm-8.78,0h7.23v11.46h-7.23Zm-8.77,0h7.23v11.46h-7.23Zm-8.77,0h7.23v11.46h-7.23Zm-8.77,0h7.23v11.46h-7.23Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,314.42v13.11h88.17V314.42Zm79.39.83H1091V326.7h-7.23Zm-8.78,0h7.23V326.7H1075Zm-8.76,0h7.23V326.7h-7.23Zm-8.78,0h7.23V326.7h-7.23Zm-8.77,0H1056V326.7h-7.23Zm-8.78,0h7.23V326.7h-7.23Zm-8.78,0h7.23V326.7h-7.23Zm-8.77,0h7.23V326.7h-7.23Zm-8.77,0h7.23V326.7h-7.23Zm-8.77,0h7.23V326.7h-7.23Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,352.57v13.1h88.17v-13.1Zm79.39.82H1091v11.46h-7.23Zm-8.78,0h7.23v11.46H1075Zm-8.76,0h7.23v11.46h-7.23Zm-8.78,0h7.23v11.46h-7.23Zm-8.77,0H1056v11.46h-7.23Zm-8.78,0h7.23v11.46h-7.23Zm-8.78,0h7.23v11.46h-7.23Zm-8.77,0h7.23v11.46h-7.23Zm-8.77,0h7.23v11.46h-7.23Zm-8.77,0h7.23v11.46h-7.23Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,390.72v13.1h88.17v-13.1Zm79.39.82H1091V403h-7.23Zm-8.78,0h7.23V403H1075Zm-8.76,0h7.23V403h-7.23Zm-8.78,0h7.23V403h-7.23Zm-8.77,0H1056V403h-7.23Zm-8.78,0h7.23V403h-7.23Zm-8.78,0h7.23V403h-7.23Zm-8.77,0h7.23V403h-7.23Zm-8.77,0h7.23V403h-7.23Zm-8.77,0h7.23V403h-7.23Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,428.87V442h82.9c.12-.27.24-.55.35-.82h-3.86V429.7H1091v2.85c.42-1.22.82-2.44,1.17-3.68Zm70.61.83h7.23v11.45H1075Zm-8.76,0h7.23v11.45h-7.23Zm-8.78,0h7.23v11.45h-7.23Zm-8.77,0H1056v11.45h-7.23Zm-8.78,0h7.23v11.45h-7.23Zm-8.78,0h7.23v11.45h-7.23Zm-8.77,0h7.23v11.45h-7.23Zm-8.77,0h7.23v11.45h-7.23Zm-8.77,0h7.23v11.45h-7.23Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,467v13.1h55.11c.32-.27.6-.56.89-.82h-2.93V467.85h7.23V475l1.55-1.65v-5.5h4.79c.23-.28.45-.56.68-.82Zm44.3.82H1056v11.46h-7.23Zm-8.78,0h7.23v11.46h-7.23Zm-8.78,0h7.23v11.46h-7.23Zm-8.77,0h7.23v11.46h-7.23Zm-8.77,0h7.23v11.46h-7.23Zm-8.77,0h7.23v11.46h-7.23Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.42,505.18v7.93a3.12,3.12,0,0,0,.43-.15v-7h7.23v4.26l1.54-.63V506h7.23v.4c.85-.39,1.69-.8,2.52-1.21Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M425.33,304.94l.05,0h0Zm54.94,237.81.9,0v0Zm58.64-119.5h0c.16-.51.31-1,.48-1.54C539.22,422.23,539.06,422.74,538.91,423.25ZM425.33,304.94l.05,0h0ZM932.14,184.29v3.44h40.47v-3.44ZM480.27,542.75l.9,0v0Zm58.64-119.5h0c.16-.51.31-1,.48-1.54C539.22,422.23,539.06,422.74,538.91,423.25ZM425.33,304.94l.05,0h0Zm54.94,237.81.9,0v0Zm58.64-119.5h0c.16-.51.31-1,.48-1.54C539.22,422.23,539.06,422.74,538.91,423.25Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 902.95,
    cy: 820.59,
    rx: 34.58,
    ry: 3.83,
    fill: "#6c63ff",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "668.32 535.25 651.04 534.3 649.87 484.67 649.6 472.85 667.83 469.49 667.95 484.73 668.32 535.25",
    fill: "#d48a9b"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "654.87 526.61 566.07 581.82 564.15 598.62 573.75 599.1 573.75 587.1 631.83 554.46 561.75 641.34 561.75 654.78 573.27 654.78 572.31 639.9 653.43 547.74 663.51 548.7 748.96 645.66 750.88 661.99 762.4 662.47 760.48 645.66 692.8 561.18 737.92 592.38 738.88 605.82 748 606.3 747.04 589.98 661.11 523.73 654.87 526.61",
    fill: "#d48a9b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M645.08,468.09A158.41,158.41,0,0,0,666,434c6.11-13.52,12.81-29.13,13.32-33.75,1-8.64,25.44-25.92,52.32-26.88,17.53-.63,44.84-14.31,61.74-23.76a125.67,125.67,0,0,1,51.8-16c19.77-1.49,38.36,2.39,29,25.33L748.48,511.16s-107.2,18.89-113.81-11.48a25.26,25.26,0,0,0-1.53-4.46C631.89,492.35,631.56,484.86,645.08,468.09Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M654.52,471.11a163.07,163.07,0,0,0,21.13-34.4c5.7-12.64,11.75-26.81,12.23-31.1.92-8.25,24.34-24.76,50.06-25.68,16.77-.6,42.9-13.66,59.06-22.69A120.41,120.41,0,0,1,846.58,342c18.91-1.42,36.7,2.29,27.78,24.2l-99.71,146s-123,17.45-129.51-11.42a28.87,28.87,0,0,0-1.53-4.48C642.47,493.44,642.31,486.43,654.52,471.11Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#dda2a6",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M769.72,520.64c-5.78,0-11.87,0-18.08-.06l-.27-11.82,18.23-3.35Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "737.92 589.5 692.8 558.3 697.97 564.75 737.92 592.38 738.88 605.82 748 606.3 747.83 603.41 738.88 602.94 737.92 589.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "573.75 584.22 573.75 587.1 627.58 556.85 631.83 551.58 573.75 584.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.75 651.9 561.75 654.78 573.27 654.78 573.08 651.9 561.75 651.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "573.75 596.22 564.47 595.76 564.15 598.62 573.75 599.1 573.75 596.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "750.88 659.11 748.96 642.78 663.51 545.82 653.43 544.86 572.31 637.02 572.48 639.71 653.43 547.74 663.51 548.7 748.96 645.66 750.88 661.99 762.4 662.47 762.07 659.57 750.88 659.11"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M759.52,426.06S782,442.5,772.16,442.69,759.52,426.06,759.52,426.06Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M665.2,516s37.2-2.88,51.12-29.76c0,0,28.32-56.17,51.37-62.41s65.76-20.16,83.52-41.76,25.21-38.16,25.21-38.16S881,361.39,866.57,382,846.89,434.35,836.81,468s-13.92,47-32.16,49c-13.75,1.45-86.45.72-121.21,0C672.07,516.69,665.2,516,665.2,516Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M665.2,516s37.2-2.88,51.12-29.76c0,0,28.32-56.17,51.37-62.41s65.76-20.16,83.52-41.76,25.21-38.16,25.21-38.16S881,361.39,866.57,382,846.89,434.35,836.81,468s-13.92,47-32.16,49c-13.75,1.45-86.45.72-121.21,0C672.07,516.69,665.2,516,665.2,516Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#dda2a6",
    opacity: 0.2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M674.56,516s35.56-2.79,48.86-28.82c0,0,27.08-54.38,49.1-60.42s62.86-19.53,79.84-40.44,24.09-36.95,24.09-36.95,4.35,17-9.41,36.95-18.81,50.66-28.45,83.2-13.3,45.55-30.74,47.41c-13.14,1.4-82.63.69-115.86,0C681.13,516.72,674.56,516,674.56,516Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M645.76,502s19.44,7.44,30.48,3.36,38.4-16.08,38.4-16.08S668.56,492.2,645.76,502Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M775.74,851.35s-55.88-3-69.5-11-32.9-8-33-8l-222.5-48.5-92.5-22-16.5-2.17,54.5-62.36,1.66-.72,80.34-34.75s36,2,43.11,25.46a28.33,28.33,0,0,1,1,5.06,29.36,29.36,0,0,1-5.68,20.54c-2.84,3.88-6.33,9.39-7.43,14.24-.62,2.74-.48,5.27,1,7.2a58.69,58.69,0,0,0,9.88,7.89c19.59,13,69.11,34.42,155.62,1.61,0,0,37-36.5,65-21S775.74,851.35,775.74,851.35Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#e1dee5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M509.28,727.15c-.62,2.74-.48,5.27,1,7.2a58.69,58.69,0,0,0,9.88,7.89L351.74,754.85,397.9,696.6l80.34-34.75s36,2,43.11,25.46a28.33,28.33,0,0,1,1,5.06,29.36,29.36,0,0,1-5.68,20.54C513.87,716.79,510.38,722.3,509.28,727.15Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "242.97 461.94 380.97 464.94 380.97 630.13 249.97 718.94 218.47 689.94 224.97 593.94 218.47 504.44 242.97 461.94",
    fill: "#a36468"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M266.24,470.85,427.36,421.2a24.41,24.41,0,0,1,8.95-1l384.9,28.09a181.82,181.82,0,0,1,91.66,32.33c24.91,17.57,49.58,44.54,61,85.38a163.05,163.05,0,0,1-1.65,91.83l-34,110s25.5-239-229-251Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#d9d6df"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M351.74,494.35V759.68s-44.15-6.21-52-14.83c-6.44-7.07-43.75-27-59.94-47.53-3.55-4.5-6.09-9-7.06-13.47-5.42-24.68-27.5-83-27.5-83l6-57,25-37,48.5-22h37.5Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#b8797d"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M281.74,497.85s-71.76,45-56.06,117.41c1.28,5.9,2.39,11.83,3.12,17.83,2.87,23.42,20.09,90.72,122.94,121.76v7l-43.63-12.17-29.62-16.33-22.61-20.28-27.64-33.72-12.83-27.5-4.7-36.22L208,574.28l6.61-35.47,15.59-23.08,19-14.77Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#d9d6df"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M351.74,494.35v42.21c-31.3,3.4-128.21,23-111,135l-.95,25.72c-3.55-4.5-6.09-9-7.06-13.47-5.42-24.68-27.5-83-27.5-83l6-57,25-37,48.5-22h37.5Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M516.71,712.91c-2.84,3.88-6.33,9.39-7.43,14.24-4.36-5-5.3-10.75,1-15.3,7.89-5.74,10.52-15.7,11.11-24.54a28.33,28.33,0,0,1,1,5.06A29.36,29.36,0,0,1,516.71,712.91Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#fff",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M920.74,739.85l-19,64.5-43,42-54,11-84-15V543.85s14.5-9.5,16-9.5,42,6.5,42,6.5l91.7,65.77,3.8,2.73,41,61Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#b8797d"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "618.97 495.44 618.97 806.44 627.07 807.89 627.07 495.44 618.97 495.44",
    fill: "#a36468"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M872.24,627.35c-60-49.3-126.7-56.55-151.5-57.45v-26s14.5-9.5,16-9.5,42,6.5,42,6.5l91.7,65.77Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M708.07,511.35l-375.83-41L290,468.11a86.81,86.81,0,0,0-70.21,29.35c-22,25.3-38.63,69.93-14.34,146.56,0,0,25.33,99.33,148,120.67l356.44,80.77c7.9,1.79,15.7,4,23.4,6.51,32.36,10.63,142,38.17,193.65-55.45,17.7-32.1,23-69.53,16.18-105.56C930.69,625.06,883.76,513.23,708.07,511.35ZM892.2,792.24C844,870.76,744.68,847.39,714.82,838.17c-7.31-2.26-14.71-4.23-22.2-5.83L363.36,761.9C249.92,743.27,226.49,656.54,226.49,656.54c-19.15-57-10.78-93.78,4.7-117.06,16.21-24.37,44.43-38,73.67-36.52l38.92,2,336.16,44.91c6.8.91,13.65,1.51,20.51,1.74,149.49,5.07,196,87.27,207.82,143.92C915.21,728.64,909.93,763.38,892.2,792.24Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#e1dee5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106,678.46c12.31,8.24,31,4.32,31,4.32s28.19-13.35,36.52-13.35,28.59-8.25,28.59-8.25l-.69-5.56-2.06-16.75c12.83,10,27.09,6.55,34.11,5.82,7.54-.78,47.83-24.73,51.71-26.31,1.05-.42,2.28-1.79,3.53-3.56h0a90.77,90.77,0,0,0,6.82-12.46h0c2.52-2.22,4.36-4,4.23-4.39s1-3.31,2.47-6.6c5.72-1,10.65-3.12,12.22-4.4a10.67,10.67,0,0,0,4-8.64s39.31-39.65,34.14-56.14,12.71-16.89,12.71-16.89,27.39-11.78,31.2-18.84c2.35-4.35,22.9-13.9,38.36-20.6l1.9-.82c6,13.15,36.48,3,42.48-2.53,6.35-5.89,25-8.64,25-8.64s.8-77,6.75-86.78c2.83-4.65,3.51-19.85,3.44-34.53,0-.52,0-1,0-1.56,8.34-1.63,28.18-5.4,37.39-6.31,5.84-.58,11.93-4.22,16.6-7.76l.55.69a11.4,11.4,0,0,0,5.07.83,7.76,7.76,0,0,0,4.45-.83c3.58-2,16.68-5.89,21.44-7.85s-.79-16.1-4.36-18.85-6-6.28-4-7.85-4.76-5.5-8.73-6.29-15.88-6.28-15.88-6.28-4.37-9-11.51-9-16.68-7.07-16.68-7.07c-.39-3.14-7.94-3.53-7.94-3.53s-28.58-22-33.35-19.24-17.86-4.32-17.86-4.32-16.07,1.8-19.85-1.16v0a4.46,4.46,0,0,0-1-2.66c-.85-2.66-5-6.3-9-9.33a35.4,35.4,0,0,0,.46-5.68c0-.82,0-1.64-.09-2.45,0-.14,0-.27,0-.41l.57-5.53a11.42,11.42,0,0,1,1.38-5.2c.67-1,1.66-1.85,2.41-2.84a7.06,7.06,0,0,0,.48-.73l.12-.21a6.54,6.54,0,0,0,.3-.59l.09-.2a9.6,9.6,0,0,0,.51-1.68l0-.13c.05-.26.09-.52.12-.79a.45.45,0,0,1,0-.11,16.75,16.75,0,0,0-.9-6.74c-1.19-3.71-3.05-7.29-3.25-11.16-.1-1.92.22-3.88-.2-5.76-1-4.29-5.37-7-9.62-8.8-5.87-2.46-8.83-5.15-13.54-8.81-4-3.1-10.62-1.54-15.66-1.22-11.52.74-22.89,4.21-33.73,7.79-4.21,1.4-8.5,3-11.78,5.85a13,13,0,0,0-4.31,7.28h0a9.52,9.52,0,0,0-.13,2c0,.06,0,.12,0,.17,0,.26,0,.51.09.76a1.87,1.87,0,0,0,0,.25,5.9,5.9,0,0,0,.22.9v0c.46,1.45,1.31,2.76,1.8,4.2a8.21,8.21,0,0,1,.27,1s0,.07,0,.1c.07.32.12.63.16,1h0c.44,3.57-.88,7.3-1.46,10.94-.08.51-.14,1-.18,1.56h0v0a18.64,18.64,0,0,0,.55,6.27.19.19,0,0,0,0,.07c.06.25.15.5.23.74a3,3,0,0,0,.1.32c.07.21.16.42.24.62l.17.42c.08.18.17.36.26.54s.15.3.23.44a5.46,5.46,0,0,0,.27.48c.09.16.19.31.29.46s.19.29.3.43.23.31.35.46l.31.38.42.44.33.33.49.42c.12.09.22.19.34.27s.41.29.62.42l.29.2c.32.19.66.36,1,.52,2.28,1,5.16,1.41,6.53,3.42a4.22,4.22,0,0,1,.67,1.56c0,.13,0,.27,0,.4v.35c0,1.16.08,2.31.2,3.44a12.73,12.73,0,0,0,.11,1.86,5.33,5.33,0,0,0,.38,1.35,35.68,35.68,0,0,0,12,20.22c.12.61.26,1.32.41,2.12a39.71,39.71,0,0,1-11.55,6c-9.53,2.79-23,15.66-23,15.66s-6.7,48.29-8.31,54.18-2.8,28.67-2.8,28.67-1.59,9.42-4,14.13c-1.69,3.32-1.38,17.59,3.32,26.26a21.9,21.9,0,0,1-2.92,4.76c-9.53,11-38.12,10.6-47.65,10.6-8.77,0-11.48,5.32-11.85,6.16-17.45,5-73.95,21.08-80.65,24-7.94,3.47-12.31,37.76-12.31,37.76S172.68,523,173.47,530.46s-5.56,28.24-5.56,28.24,0,23.49-2.69,25.08a.25.25,0,0,1-.08.05c-2.78,1.18-2.39,12.57-2.39,12.57s2.05.59,5.24,1.4c-.85,5.75-4,13.8-6.43,19.52-1.24-1.57-2.45-2.22-3.17-.4-2,5-31.76,40.34-39.31,40.34-3.59,0-9.53,2.94-13.44,6.91C101.36,668.54,99.54,674.15,106,678.46ZM242.55,473.89c33.75,3.14,69.88-2.39,69.88-2.39s-2.78,9.85-5.16,13.78-9.14,26.31-9.14,31-10.72,45.15-13.89,47.11c-1.33.83-2.52,2.89-3.46,5a46.94,46.94,0,0,0-2.1,6q.07,1.53.27,2.91c-2.37,2.17-4.88,4.45-7.11,6.47h0s-14.2,7.9-19,12.22-27,9.62-27,9.62a138.21,138.21,0,0,0-16,8.15c-6.89,4.15-13.78,9.43-15.58,14.64.78-8.78,2.05-19.35,2.9-26.07l1.26-.05c11.13-.69,9.47-11.31,8.88-13.94-.08-.38-.14-.59-.14-.59,7.94-8.64,25.8-73,23.42-80.1s2-13.35,2.93-13.35,2.23-7.85.25-12.17S242.55,473.89,242.55,473.89Zm272.9-173.22-2.11.52,0-.45S514.11,300.74,515.45,300.67ZM400.09,241.42c-.32.4-.64.78-1,1.15l-.41.42c0-.73,0-1.47,0-2.18C399.16,241,399.62,241.23,400.09,241.42ZM360.32,317.6l.14,2.21s-.21,1.35-.61,3.66Zm182.45-21.94-6.93,1.19c1-.37,1.95-.77,2.89-1.22a6.65,6.65,0,0,1,2.21-.6,12.69,12.69,0,0,1,2.58.55A4.78,4.78,0,0,0,542.77,295.66Z",
    transform: "translate(-101.77 -35.91)",
    fill: "url(#e507827f-2863-48fa-82fe-b741cb149057)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M308.48,579.14s-8,16.51-7.59,17.68S283.74,612,283.74,612l-19.09-13.63,2-9.36s21.43-19.31,23-21.54S308.48,579.14,308.48,579.14Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#efb7b9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M199.58,635c13.25,12.86,28.83,9,36.24,8.19s46.94-24.55,50.74-26.11c1-.42,2.25-1.78,3.47-3.54h0a89.92,89.92,0,0,0,6.69-12.37c-.26.07-13.22,3.78-16.49,0,0,0-5.46-6.69-6.63-6.69s-.09-11.74-.09-11.74-13.94,7.84-18.61,12.13-26.5,9.54-26.5,9.54a134,134,0,0,0-15.68,8.09C202.4,618.8,192,627.69,199.58,635Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#67647e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M199.58,635c13.25,12.86,28.83,9,36.24,8.19s46.94-24.55,50.74-26.11c1-.42,2.25-1.78,3.47-3.54-4.61-2.75-34.73,16.4-43.16,19.91S217.11,635,205,629.94c-6-2.53.08-10.3,7.7-17.44C202.4,618.8,192,627.69,199.58,635Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M201.14,594.48s-5.55,41.69-4.14,47.15-34.83-18.7-34.83-18.7,12.68-26.13,9-32.13S201.14,594.48,201.14,594.48Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#efb7b9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M166.46,595.26s22.6,6.62,35.06,5.84c10.92-.68,9.29-11.22,8.72-13.83-.08-.37-.14-.58-.14-.58,7.79-8.58,25.33-72.48,23-79.49S235,494,236,494s2.19-7.8.24-12.08,8.58-8.18,8.58-8.18c33.12,3.11,68.58-2.38,68.58-2.38s-2.73,9.78-5.07,13.68-9,26.1-9,30.78-10.52,44.81-13.64,46.76c-1.3.82-2.47,2.86-3.39,5a46.75,46.75,0,0,0-2.06,6c1.17,26.11,30.78,16,35.07,12.47a11.5,11.5,0,0,0,1.66-1.7,10.9,10.9,0,0,0,2.23-6.88s38.58-39.35,33.51-55.72,12.47-16.75,12.47-16.75,26.89-11.69,30.63-18.71c2.31-4.31,22.47-13.78,37.65-20.44,9.51-4.17,17.06-7.22,17.06-7.22l-6.32-22.66-5-17.87-9.38-3.52-30-11.28L346,395.75l-4.93.64-52.29,6.77S212.44,425,204.64,428.42s-12.08,37.47-12.08,37.47S176.2,522.39,177,529.83s-5.46,28-5.46,28,0,23.31-2.65,24.89a.14.14,0,0,1-.08,0C166.07,584,166.46,595.26,166.46,595.26Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#444053"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M244.78,473.69c33.12,3.11,68.58-2.38,68.58-2.38,2.34-7.37,35.09-27.63,35.09-27.63C321.58,437.06,244.78,473.69,244.78,473.69Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M280.24,573.44c1.17,26.11,30.78,16,35.07,12.47a11.5,11.5,0,0,0,1.66-1.7c-10.35,3.81-28.7,6.76-34.67-16.73A46.75,46.75,0,0,0,280.24,573.44Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#444053"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M166.46,595.26s22.6,6.62,35.06,5.84c10.92-.68,9.29-11.22,8.72-13.83-11.44-.36-31.14-1.43-41.37-4.53a.14.14,0,0,1-.08,0C166.07,584,166.46,595.26,166.46,595.26Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#444053"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M280.24,573.44c1.17,26.11,30.78,16,35.07,12.47a11.5,11.5,0,0,0,1.66-1.7c-10.35,3.81-28.7,6.76-34.67-16.73A46.75,46.75,0,0,0,280.24,573.44Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M166.46,595.26s22.6,6.62,35.06,5.84c10.92-.68,9.29-11.22,8.72-13.83-11.44-.36-31.14-1.43-41.37-4.53a.14.14,0,0,1-.08,0C166.07,584,166.46,595.26,166.46,595.26Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M110.73,676.7c12.08,8.18,30.4,4.28,30.4,4.28s27.66-13.24,35.85-13.24S205,659.55,205,659.55l-.67-5.51-3.22-26.44s-30.35-.78-31.57-3.51c0,0-5.45-13.42-7.4-8.46s-31.17,40-38.58,40c-3.53,0-9.36,2.92-13.19,6.86C106.2,666.86,104.41,672.42,110.73,676.7Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#67647e"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M215.55,446.41s25.33,16,18.32,19.48S215.55,446.41,215.55,446.41Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M205,477.19s21.82,20.72,13.64,21.27S205,477.19,205,477.19Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M181.65,543s11.08,20.83,6.91,24.44S181.65,543,181.65,543Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M303.62,564.09c-3.9,3.89,37-12.86,27.66-13.64S303.62,564.09,303.62,564.09Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M385.44,271.84l1.31-.19c4.84-.74,22.41-3.5,38.17-6.92,3.84-.84,7.56-1.71,11-2.61,12.07-3.16,20.17-6.57,15-9.37-6.84-3.71-10.44-10.45-12.34-16.25-.18-.57-.35-1.12-.51-1.67a43.31,43.31,0,0,1-1.57-9s-44-15.59-35.46,0c4.21,7.65,1.38,13.89-2.59,18.26a34.28,34.28,0,0,1-9.49,7.07Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#efb7b9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M432.59,259.76s-15.75,11.3-31.84,1.95-37.13,82.61-37.13,82.61L341.8,398.09s-14.13,11.69,3.46,16.76,56.61-5.07,66.52,9.74,28.67,17.14,30.59,17.14S451.71,386,451.71,386l1.93-80.66Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M346,411.73c17.59,5.06,56.62-5.07,66.53,9.74A38.06,38.06,0,0,0,429.32,435a44,44,0,0,0,13.83,3.66c.25,0,.62-1,1.05-2.79,2.74-11.28,8.29-52.94,8.29-52.94l1.92-80.66L435.9,262.12l-2.53-5.48a33.39,33.39,0,0,1-8,3.91c-6.09,2.06-14.9,3.22-23.82-2-4.72-2.74-9.87,3.24-14.78,13.06-11.84,23.64-22.35,69.55-22.35,69.55L342.58,395a18.52,18.52,0,0,0-1.48,1.42C338,399.66,332.19,407.75,346,411.73Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#f3f5f9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M429.84,414.44a102.22,102.22,0,0,0-.52,20.52,240.33,240.33,0,0,0,3.66,29,11.43,11.43,0,0,0,.48,1.77c9.51-4.17,17.06-7.22,17.06-7.22l-6.32-22.66c2.74-11.28,8.29-52.94,8.29-52.94l1.92-80.66L435.9,262.12c12.07-3.16,20.17-6.57,15-9.37-7.5-4.07-11.11-11.79-12.85-17.92A65.05,65.05,0,0,1,427,246.75l-.24.2-1.4,13.6-.43,4.18-.9,8.67s4.29,102.48,7.4,108.33,1.56,17.14-1.16,30.39C430.1,412.87,430,413.64,429.84,414.44Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M431.81,410.56c-2.72,13.25-.39,35.07,2.73,51.82s36.24,5.85,42.48,0,24.54-8.57,24.54-8.57.78-76.37,6.63-86.11c2.77-4.62,3.44-19.7,3.37-34.27-.05-13.08-.7-25.75-.94-30-.06-1-.09-1.55-.09-1.55s25.32-42.86,24.93-46-7.79-3.5-7.79-3.5-28-21.82-32.73-19.1S477.4,229,477.4,229s-16.29,1.85-19.66-1.3a1.72,1.72,0,0,1-.6-1.43c.38-5-16.6-15.64-17.13-16,14.32,12.88-8.83,32.73-11.46,34.91l-.24.2-2.73,26.45s4.29,102.48,7.4,108.33S434.54,397.31,431.81,410.56Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#67647e"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 331.55,
    cy: 263.33,
    r: 1.95,
    fill: "#444053"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M429.33,246.75l11.84,11.45,17.35-29a1.72,1.72,0,0,1-.6-1.43c.38-5-16.61-15.64-17.13-16C455.11,224.72,432,244.57,429.33,246.75Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.45,
    cy: 325.67,
    r: 1.95,
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.45,
    cy: 324.89,
    r: 1.95,
    fill: "#444053"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M428.55,245.19l11.84,11.45,17.35-29a1.72,1.72,0,0,1-.6-1.43c.38-5-16.6-15.64-17.13-16C454.33,223.16,431.18,243,428.55,245.19Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#67647e"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 416.9,
    y: 297.32,
    width: 27.12,
    height: 57.3,
    rx: 1.7,
    ry: 1.7,
    transform: "translate(751.61 625.75) rotate(-178.69)",
    fill: "#d1d9ec"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 417.05,
    y: 298.58,
    width: 27.12,
    height: 57.3,
    rx: 1.7,
    ry: 1.7,
    transform: "translate(751.87 628.28) rotate(-178.69)",
    fill: "#dfe6f5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.56,
    cy: 279.43,
    r: 4.26,
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M284.52,407.05c9.74,4.29,73.65-7,83-9.74s23-23.77,16.37-39,2.33-30,2.33-30,14-30,17.15-35.85,9.62-22.86,10.52-25.71a2.34,2.34,0,0,0-.55-1.79C410.8,261.13,401,254.31,401,254.31c-2.75,1-3.09-6.89-3-12.68.06-3.24.25-5.82.25-5.82s-1.29,1.31-3.4,3.1c-.77.65-1.65,1.37-2.63,2.11A40.43,40.43,0,0,1,380,247.73c-9.35,2.77-22.6,15.54-22.6,15.54l3.9,59.84s-9,56.28-18.32,67.19-37.41,10.52-46.76,10.52S284.52,407.05,284.52,407.05Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M283.74,404.72c9.74,4.28,73.65-7,83-9.75s23-23.77,16.37-39,2.33-30,2.33-30,14-30,17.15-35.85,9.62-22.86,10.52-25.71a2.35,2.35,0,0,0-.55-1.79C410,258.8,400.25,252,400.25,252c-2.75,1-3.09-6.88-3-12.67.06-3.25.25-5.83.25-5.83s-1.29,1.31-3.4,3.11c-.77.64-1.65,1.36-2.63,2.1a40.43,40.43,0,0,1-12.28,6.71c-9.35,2.77-22.6,15.54-22.6,15.54l3.9,59.84s-9,56.28-18.32,67.19-37.4,10.52-46.76,10.52S283.74,404.72,283.74,404.72Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#67647e"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M389.73,235s.37,2.05,1,5.21c2.1,10.7,7.1,34.06,10.71,33.16,2.59-.65,7-5.23,10.36-9.19-2.53-3.86-12.31-10.68-12.31-10.68-2.75,1-3.09-6.88-3-12.67l-3.15-2.72Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M390.51,233.47s.37,2.05,1,5.21c2.1,10.7,7.1,34.06,10.71,33.16,2.59-.65,7-5.23,10.36-9.19C410,258.8,400.25,252,400.25,252c-2.75,1-3.09-6.88-3-12.67l-3.15-2.72Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#67647e"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M365.57,348.21s19.49-3.89,24.94-12.46,42.57-16,38-7-38,38.29-38,38.29L376,387.81l-19.38-4.92L348.45,367Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#efb7b9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M411.67,370.45s-18.87,7-21.71,16.36S411.67,370.45,411.67,370.45Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M423.24,381.34s1.72,9.73-21.93,9Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M525.33,256.64l8.58-.78s9.35,7,16.36,7,11.3,9,11.3,9,11.69,5.46,15.59,6.24,10.52,4.67,8.57,6.23.39,5.07,3.9,7.79,9,16.76,4.28,18.71-17.53,5.84-21,7.79-7.79,0-7.79,0-20.64-26.89-31.17-21.82S509,301.84,509,301.84l-11.3-23.76Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M346,384.86c1.84,2.74,4.22,4.66,7.27,5.05a55,55,0,0,0,22.69-2.1s-39.25-12.47-1.46-42.79H364.4L361,343.74l1.54-8.07,2.22-72.79-8.18-1.95s-6.59,47.93-8.16,53.77-2.75,28.45-2.75,28.45-1.56,9.35-3.9,14C340,360.69,340.49,376.54,346,384.86Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#67647e"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M347.59,384.86c1.83,2.74,4.22,4.66,7.27,5.05a55,55,0,0,0,22.69-2.1S338.3,375.34,376.09,345H366l-3.37-1.28C357,353.57,348.3,371.06,347.59,384.86Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M346,384.86c1.84,2.74,4.22,4.66,7.27,5.05a55,55,0,0,0,22.69-2.1s-39.25-12.47-1.46-42.79H364.4L361,343.74C355.48,353.57,346.74,371.06,346,384.86Z",
    transform: "translate(-101.77 -35.91)",
    fill: "none"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M346,384.86c1.84,2.74,4.22,4.66,7.27,5.05a55,55,0,0,0,22.69-2.1s-39.25-12.47-1.46-42.79H364.4L361,343.74C355.48,353.57,346.74,371.06,346,384.86Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#67647e"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M398.44,244.12a35.47,35.47,0,0,0,40.13-7.62c-.18-.57-.35-1.12-.51-1.67a43.31,43.31,0,0,1-1.57-9s-44-15.59-35.46,0C405.24,233.51,402.41,239.75,398.44,244.12Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M377.65,210.27v.35c0,1.15.08,2.29.2,3.41s.28,2.14.48,3.19a35.47,35.47,0,0,0,68.32,4.58c.24-.69.45-1.38.64-2.08a35.06,35.06,0,0,0,1.28-9.45c0-.81,0-1.63-.09-2.43a35.46,35.46,0,0,0-70.83,2.43Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#efb7b9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M377.65,210.62a15.27,15.27,0,0,1,.2,3.41,12.67,12.67,0,0,0,.1,1.85,5.25,5.25,0,0,0,.38,1.34c1.43,3.36,6.11,5.54,9.2,3.37a9.86,9.86,0,0,0,2.76-3.62c3.28-6.09,7.83-13.09,15-13.21,3.06-.06,5.93,1.23,8.89,2s6.46.84,8.66-1.17c1.7-1.55,2.5-4.19,4.77-4.73s4.37,1.54,5.41,3.58,1.87,4.44,4,5.5c.94.46,2,.6,3,1.1,4.24,2.32,2.29,10.45,6.69,11.77a3.2,3.2,0,0,0,.42.1c.07-.72.15-1.46.22-2.18q.6-5.94,1.19-11.88a35.46,35.46,0,0,0-70.83,2.43Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M440.64,157.34c4.17,1.77,8.51,4.49,9.44,8.74.41,1.87.1,3.81.2,5.71.2,3.84,2,7.4,3.19,11.08s1.59,8-.75,11.1c-.73,1-1.7,1.79-2.36,2.81A11.5,11.5,0,0,0,449,202l-1.93,19.18c-4.94-.93-2.74-9.5-7.12-11.88-.91-.5-2-.64-2.95-1.11-2.11-1-2.93-3.45-4-5.49s-3.1-4.13-5.41-3.58-3.07,3.19-4.76,4.73c-2.21,2-5.72,1.92-8.67,1.17s-5.83-2-8.88-2c-7.18.12-11.74,7.12-15,13.21a9.89,9.89,0,0,1-2.77,3.63c-3.48,2.44-9-.64-9.57-4.72-.34-2.29.38-4.84-.94-6.78s-4.18-2.35-6.41-3.39c-5.7-2.62-7.46-9.73-6.52-15.69.69-4.3,2.4-8.72,1-12.86-.49-1.43-1.32-2.73-1.77-4.16-1.25-4,.79-8.44,4-11.29s7.42-4.42,11.56-5.8c10.63-3.57,21.79-7,33.1-7.74,4.95-.32,11.44-1.87,15.37,1.22C432,152.23,434.88,154.9,440.64,157.34Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#585268"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.6,
    cy: 232.54,
    r: 1.95,
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.6,
    cy: 231.76,
    r: 1.95,
    fill: "#444053"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.07,
    cy: 354.9,
    r: 1.95,
    opacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 342.07,
    cy: 354.12,
    r: 1.95,
    fill: "#444053"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.45,
    cy: 387.24,
    r: 1.95,
    opacity: 0.1
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.45,
    cy: 386.46,
    r: 1.95,
    fill: "#444053"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M370.25,299.24s-4.29,29.1,0,34.17S370.25,299.24,370.25,299.24Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M497.67,353.28s8.18,17.63,0,34.53-13.25,23.77-10.52,34.56S497.67,353.28,497.67,353.28Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M110.73,676.7c12.08,8.18,30.4,4.28,30.4,4.28s27.66-13.24,35.85-13.24S205,659.55,205,659.55l-.67-5.51c-8.07,1.55-26.43,5.26-28.55,7.07-2.73,2.34-36.24,13.64-36.24,13.64s-22.82-2.85-29.17-12.23C106.2,666.86,104.41,672.42,110.73,676.7Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.28,168.67c0-.42,0-.84,0-1.27,0,.49,0,1,0,1.46C450.3,168.8,450.28,168.74,450.28,168.67Z",
    transform: "translate(-101.77 -35.91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.6,201.82c2.23,1,5,1.4,6.41,3.38s.6,4.49.94,6.78c.59,4.08,6.09,7.17,9.57,4.72a9.89,9.89,0,0,0,2.77-3.63c3.27-6.09,7.83-13.09,15-13.21,3.06-.05,5.93,1.24,8.89,2s6.46.84,8.67-1.17c1.69-1.54,2.49-4.19,4.76-4.73s4.36,1.54,5.41,3.58,1.87,4.44,4,5.5c.94.46,2,.6,2.95,1.1,4.38,2.39,2.18,11,7.12,11.88q1-9.6,1.93-19.18a11.46,11.46,0,0,1,1.36-5.16c.66-1,1.63-1.84,2.36-2.82a8.59,8.59,0,0,0,1.6-4.12,10,10,0,0,1-1.6,7.24c-.73,1-1.7,1.79-2.36,2.81A11.5,11.5,0,0,0,449,202q-1,9.59-1.93,19.18c-4.94-.93-2.74-9.5-7.12-11.88-.91-.5-2-.64-2.95-1.11-2.11-1-2.93-3.45-4-5.49s-3.1-4.13-5.41-3.58-3.07,3.19-4.76,4.73c-2.21,2-5.72,1.92-8.67,1.17s-5.83-2-8.89-2c-7.17.12-11.73,7.12-15,13.21a9.89,9.89,0,0,1-2.77,3.63c-3.48,2.44-9-.64-9.57-4.72-.34-2.29.38-4.84-.94-6.78s-4.18-2.35-6.41-3.39c-5.21-2.4-7.13-8.55-6.69-14.14C364.29,195.4,366.35,199.86,370.6,201.82Z",
    transform: "translate(-101.77 -35.91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.31,169.1c.45,1.43,1.28,2.74,1.77,4.16a12,12,0,0,1,.44,5.13,10,10,0,0,0-.44-2c-.49-1.43-1.32-2.73-1.77-4.16a8.78,8.78,0,0,1-.23-4.07A8.2,8.2,0,0,0,363.31,169.1Z",
    transform: "translate(-101.77 -35.91)"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M583.14,490.05,502.82,480a3.07,3.07,0,0,1-1.83-5.18l33.69-35a3.06,3.06,0,0,1,2.56-.92l61.41,6.88a3.07,3.07,0,0,1,2.52,4.16l-14.78,38.19A3.08,3.08,0,0,1,583.14,490.05Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#746d83"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M583.14,490.05,502.82,480a3.07,3.07,0,0,1-1.83-5.18l33.69-35a3.06,3.06,0,0,1,2.56-.92l61.41,6.88a3.07,3.07,0,0,1,2.52,4.16l-14.78,38.19A3.08,3.08,0,0,1,583.14,490.05Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M582.23,489.15l-80.31-10.09a3.08,3.08,0,0,1-1.83-5.19l33.69-35a3.1,3.1,0,0,1,2.56-.93l61.4,6.88a3.08,3.08,0,0,1,2.53,4.17l-14.79,38.19A3.09,3.09,0,0,1,582.23,489.15Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#746d83"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M534.37,452.58l24.12,1.94,34.4-2.24-.59,0-31.87-3.08c-7.3-2.68-2.24-18.46-2.24-18.46l-24.41,1.24-1.95.1C523.2,452.28,534.37,452.58,534.37,452.58Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#d1d9ec"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M534.37,452.58l24.12,1.94,34.4-2.24-.59,0-34.78,1.24-23.3-2.53c-6.62-1.74-2.83-13.22-.44-19l-1.95.1C523.2,452.28,534.37,452.58,534.37,452.58Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M492.12,309.15,499.5,415l1,13.89a6,6,0,0,0,6.06,5.61h2.24l111.1-.67a3.13,3.13,0,0,0,3.08-3.43l-1-13.9-7.82-93.08a6.39,6.39,0,0,0-4.27-5.4L504,302.14c-3.6-1.25-7.27-.81-9.56,1.1A6.72,6.72,0,0,0,492.12,309.15Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#4c4c56"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M499.5,415l1,13.89a6,6,0,0,0,6.06,5.61h2.24l111.1-.67a3.13,3.13,0,0,0,3.08-3.43l-1-13.9Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#dfe6f5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 472.21,
    cy: 390.61,
    rx: 1.49,
    ry: 2.98,
    fill: "#fff"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M569.66,466.13s-30.38-11.47-38.57-3.13c0,0-1.34,2.54,4.17,3.13l22.26,1.79S566.68,468.81,569.66,466.13Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#d1d9ec"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M568.85,463.15c-6-2.44-23.93-8.75-35.43-1.77,0,0,12.72-1.41,19.71,2.63s16.53,2.12,16.53,2.12l.14-.25A1.93,1.93,0,0,0,568.85,463.15Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#dfe6f5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M492.12,309.15l8.34,119.76a6,6,0,0,0,6.06,5.61h2.24a21.34,21.34,0,0,1-3.88-5s-8.19-120.34-8.79-123.32a6.1,6.1,0,0,0-1.65-2.94A6.72,6.72,0,0,0,492.12,309.15Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#dfe6f5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M492.12,309.15l8.34,119.76a6,6,0,0,0,6.06,5.61h2.24a21.34,21.34,0,0,1-3.88-5s-8.19-120.34-8.79-123.32a6.1,6.1,0,0,0-1.65-2.94A6.72,6.72,0,0,0,492.12,309.15Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M477.79,342.35c9-2,30-8.16,30-8.16l3.76-.76c-.05-13.08-.7-25.75-.94-30h-.09s-17.93,5.85-22.21,9-17.54,2.33-17.54,2.33S450.13,315.87,433,335,468.83,344.32,477.79,342.35Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M565.38,307.58a5.21,5.21,0,0,1,1.17,8.74c-4.75,3.93-11.68,8.63-18.3,9.29-11,1.11-37.6,6.44-40.24,7a3.2,3.2,0,0,0-.42.1c-2.19.64-21.35,6.25-29.8,8.1-9,2-62,11.71-44.81-7.38,15.78-17.58,34.53-20,37.42-20.23a4,4,0,0,1,.69,0c2,.09,13.32.48,17.23-2.35a36.81,36.81,0,0,1,6.44-3.21,123.2,123.2,0,0,1,26.35-7.6l18.33-3.2a5.26,5.26,0,0,1,3.08.4Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#efb7b9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M526.89,256.64l8.57-.78s9.36,7,16.37,7,11.3,9,11.3,9,11.69,5.46,15.59,6.24,10.52,4.67,8.57,6.23.39,5.07,3.9,7.79,9,16.76,4.28,18.71-17.53,5.84-21,7.79-7.79,0-7.79,0S546,291.71,535.47,296.78s-24.94,5.06-24.94,5.06l-11.3-23.76Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#67647e"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1040,746.64a16.86,16.86,0,0,0-2.27,4.29c-.15.37-.28.8-.42,1.21a4.65,4.65,0,0,0-.79-.28,11,11,0,0,0-3.57-.3c0-.47,0-.95.07-1.47.14-5.27-.48-12.61-5.5-9.5-4.83,3-1.39,8,1.72,11.2l.8.79c-2.83,2-3.37,6.73-3.85,11.64s-4.64,10.28-7.4,13.33c-.28.32-.54.59-.78.85a10.15,10.15,0,0,0-8-2.07l-.37-1.35c-2.24-8.09-6.89-22.1-12.82-25.17.25-.31.51-.63.78-1,2.52-3.29,5.35-8.19,1.16-9.44s-4.56,4.25-4.33,8.36q0,.78.12,1.47a6.15,6.15,0,0,0-4.39,2.14l-.64-.77c-3.4-4-9.64-10.37-11.52-5.56-1.76,4.48,3.73,10.3,7.59,13.67l.24.21c-2.6,10.51,8.72,19.08,14.81,22.83l.78.48c-8.4,9.9-13.58,28.46-13.58,28.46l23.52,4.2s15.59-13.46,13.6-26.1l.16,0c15.58-3.12,19.13-19.74,16.7-29.6l.28-.12a17.69,17.69,0,0,0,7.21-5.46C1053.62,747.53,1044.47,740.69,1040,746.64Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1040,746.64a16.86,16.86,0,0,0-2.27,4.29c-.15.37-.28.8-.42,1.21a4.65,4.65,0,0,0-.79-.28,11,11,0,0,0-3.57-.3c0-.47,0-.95.07-1.47.14-5.27-.48-12.61-5.5-9.5-4.83,3-1.39,8,1.72,11.2l.8.79c-2.83,2-3.37,6.73-3.85,11.64s-4.64,10.28-7.4,13.33c-.28.32-.54.59-.78.85a10.15,10.15,0,0,0-8-2.07l-.37-1.35c-2.24-8.09-6.89-22.1-12.82-25.17.25-.31.51-.63.78-1,2.52-3.29,5.35-8.19,1.16-9.44s-4.56,4.25-4.33,8.36q0,.78.12,1.47a6.15,6.15,0,0,0-4.39,2.14l-.64-.77c-3.4-4-9.64-10.37-11.52-5.56-1.76,4.48,3.73,10.3,7.59,13.67l.24.21c-2.6,10.51,8.72,19.08,14.81,22.83l.78.48c-8.4,9.9-13.58,28.46-13.58,28.46l23.52,4.2s15.59-13.46,13.6-26.1l.16,0c15.58-3.12,19.13-19.74,16.7-29.6l.28-.12a17.69,17.69,0,0,0,7.21-5.46C1053.62,747.53,1044.47,740.69,1040,746.64Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M993.17,753.42l-2.75,8.05s-1.52-1.08-3.45-2.78c-3.86-3.37-9.35-9.19-7.59-13.67,1.88-4.81,8.12,1.54,11.52,5.56C992.27,752.18,993.17,753.42,993.17,753.42Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M999,748.82A38.1,38.1,0,0,1,996.3,752a39,39,0,0,1-.49-4.24c-.23-4.11.2-9.59,4.33-8.36S1001.5,745.53,999,748.82Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.45,750.09c-.09,2.65-.35,4.77-.35,4.77a34.68,34.68,0,0,1-3.43-3.07c-3.11-3.22-6.55-8.21-1.72-11.2C1034,737.48,1034.59,744.82,1034.45,750.09Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.69,753.56a17.69,17.69,0,0,1-7.21,5.46,19.38,19.38,0,0,1-2.42.88l-3.24-4.55a32.17,32.17,0,0,1,1.34-4.42,16.86,16.86,0,0,1,2.27-4.29C1045.91,740.69,1055.06,747.53,1050.69,753.56Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M990.9,750.58c1.37,1.6,2.27,2.84,2.27,2.84l-2.75,8.05s-1.52-1.08-3.45-2.78a15.68,15.68,0,0,1,3.09-7.07C990.34,751.24,990.63,750.9,990.9,750.58Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M999,748.82A38.1,38.1,0,0,1,996.3,752a39,39,0,0,1-.49-4.24A5.55,5.55,0,0,1,999,748.82Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.5,780.78l-6.84,3a41.38,41.38,0,0,1-3.64-2.06c-7.19-4.42-21.65-15.55-12-28.67s17.77,10.41,21,21.92C1012,778.42,1012.5,780.78,1012.5,780.78Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.67,751.79a5.67,5.67,0,0,1,3.78-1.7c-.09,2.65-.35,4.77-.35,4.77A34.68,34.68,0,0,1,1030.67,751.79Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.48,759a19.38,19.38,0,0,1-2.42.88l-3.24-4.55a32.17,32.17,0,0,1,1.34-4.42C1041.25,752.15,1042.79,755.19,1043.48,759Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.5,788.74c-.38.08-.76.15-1.15.21-22.93,3.48-7.56-8.89-7.56-8.89s1-.95,2.43-2.51c2.76-3,6.93-8.39,7.4-13.33.72-7.43,1.56-14.4,10.33-12.36C1046.56,753.88,1048.2,784.4,1026.5,788.74Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 880.49,
    y: 809.92,
    width: 43.81,
    height: 11.52,
    fill: "#d4dfec"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 873.53,
    y: 772.48,
    width: 57.24,
    height: 40.2,
    fill: "#d4dfec"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 880.49,
    y: 809.92,
    width: 43.81,
    height: 11.52,
    opacity: 0.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 873.53,
    y: 772.48,
    width: 57.24,
    height: 40.2,
    opacity: 0.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 883.37,
    y: 809.92,
    width: 43.81,
    height: 11.52,
    fill: "#d4dfec"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1011,775c1,3.44,1.48,5.8,1.48,5.8l-6.84,3a41.38,41.38,0,0,1-3.64-2.06C1004.7,778.33,1007.72,775.77,1011,775Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.5,788.74c-.38.08-.76.15-1.15.21-22.93,3.48-7.56-8.89-7.56-8.89s1-.95,2.43-2.51C1024.5,781,1026.27,784.84,1026.5,788.74Z",
    transform: "translate(-101.77 -35.91)",
    opacity: 0.1
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M989.22,810.67s12.84-46,30.84-31.8-7.32,36-7.32,36Z",
    transform: "translate(-101.77 -35.91)",
    fill: "#6c63ff"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 893.93,
    cy: 724.35,
    r: 1.44,
    opacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 893.81,
    cy: 731.07,
    r: 1.44,
    opacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 935.57,
    cy: 725.67,
    r: 1.44,
    opacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 901.97,
    cy: 760.12,
    r: 1.44,
    opacity: 0.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 932.57,
    cy: 736.83,
    r: 1.44,
    opacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 917.69,
    cy: 751.72,
    r: 1.44,
    opacity: 0.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 898.85,
    cy: 727.23,
    r: 1.44,
    opacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 931.61,
    cy: 729.99,
    r: 1.44,
    opacity: 0.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 926.69,
    cy: 741.15,
    r: 1.44,
    opacity: 0.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 911.57,
    cy: 759.04,
    r: 1.44,
    opacity: 0.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 908.45,
    cy: 751.96,
    r: 1.44,
    opacity: 0.1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 901.01,
    cy: 735.99,
    r: 1.44,
    opacity: 0.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 883.37,
    y: 809.92,
    width: 43.81,
    height: 4.21,
    opacity: 0.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 876.41,
    y: 772.48,
    width: 57.24,
    height: 40.2,
    fill: "#d4dfec"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 913.49,
    cy: 765.52,
    r: 1.44,
    opacity: 0.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 904.85,
    cy: 767.32,
    r: 1.44,
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManOnTable);
export default __webpack_public_path__ + "static/media/manOnTable.8f117eb207e57ed8f89d67d595aceb45.svg";
export { ForwardRef as ReactComponent };